import { ca } from '@cian/analytics';

import { TAnalyticsKey } from '../../types/chatHint';
import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

export const trackHintQuestionClick = (offer: TOffer | undefined, questionName: TAnalyticsKey) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Messages',
    action: 'click_sopr',
    label: 'short_question',
    products: offer ? getProducts([offer], { questionName }) : [],
  });
};
